import React, { Component } from "react";
import DialogPromptStyle from "./DialogPromptViewStyle";
import DialogPromptViewProps from "./DialogPromptViewProps";

export default class DialogPromptView extends Component<DialogPromptViewProps> {

    private _style = new DialogPromptStyle();

    render() {
        return (
            <span style={{ ...this._style.prompt, ...this.props.style }}>
                {this.props.children}
            </span>
        );
    }
}